import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C5IssuersEdit } from "./edit";
import { C5IssuersNew } from "./new";
import { C5IssuersTable } from "./table";

export default function C5Issuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Émetteurs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C5IssuersEdit />} />
      <Route index element={<C5IssuersTable />} />
      <Route path="/new" element={<C5IssuersNew />} />
    </Routes>
  );
}
